import { defineAction } from '~/prix'
import { z } from 'zod'
import equipmentLoanCreateAction from './equipmentLoanCreate.action.json' with { type: 'json' }
import equipmentLoanObject from '../equipmentLoanObject'
import { protocolObject } from '~/packages/general/protocol/protocolObject'

const equipmentLoanCreateDefinition = defineAction({
  ...equipmentLoanCreateAction,

  input: equipmentLoanObject.pick({
    equipmentId: true,
    loanDate: true,
    estimatedDevolutionDate: true,
    citizenId: true,
  }),
  output: equipmentLoanObject
    .pick({
      id: true,
    })
    .extend({
      protocolId: protocolObject.shape.id,
      protocolCode: protocolObject.shape.code,
    }),
})

export default equipmentLoanCreateDefinition
